import React from "react";
import createApp from "../../assets/images/create.svg";
export interface ICreateAppBtnProps {
  appFormHandler: (isOpen: boolean, title: string, appData: any) => void;
  title: string;
}
const CreateAppBtn: React.FC<ICreateAppBtnProps> = (props) => {
  const hitCreateBtn = () => {
    let isOpen = true;
    let titlel = props.title;
    let appData = {
      ipEditable: true
    }
    props.appFormHandler(isOpen, titlel, appData);
  };

  return (
    <div>
      <button onClick={hitCreateBtn} className="custom-btn block-btn">
        <img src={createApp} alt="create an app" />
        <span>Create New App</span>
      </button>
    </div>
  );
};

export default CreateAppBtn;
